




























































































































import { getArticles, getUsers, getArticle, getUser, postAutomation, generateAutomationsReport } from '@/api/api';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { addTypeContract } from '@/api/api'
import AutomationDatatable from '@/components/AutomationDatatable.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import MetaDatatable from '@/models/MetaDatatable';
import User from '@/models/User';
import Lot from '@/models/Lot';
// @ts-ignore
import localeDatePicker from 'ant-design-vue/lib/date-picker/locale/fr_FR';
import moment from 'moment';
import { saveAs } from 'file-saver';


const automationReset = {
    user: null,
    articles: [],
    start_at: null
}

@Component({
    components: {
        AutomationDatatable,
        FilterComponent
    },
})
export default class Automation extends Vue {
    showAddAutomation = false;
    error = '';
    reload = false;
    localeDatePicker = localeDatePicker;

    meta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 0,
        perPage: 5,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: { roles: 'ROLE_PRESCRIBER', role: 'ROLE_PRESCRIBER' },
        exclusions: null,
    };

    metaArticle: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 5,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescriber: undefined,
            program: undefined,
            status: undefined,
            customer: undefined,
        },
    };

    article: any;
    user: any;
    filter = '';

    automation: any = {
        user: null,
        articles: [],
        start_at: null
    }

    async exportAutomations() {
        const $vs = (this as any).$vs;
        try {
            const { data } = await generateAutomationsReport()
            console.log(data)
            const fileName = "export.xlsx";
            saveAs(data, fileName);

        } catch (error) {
            console.log(error)
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text:
                    'Une erreur est survenue lors de la récupération du excel',
            });
        }
    }

    isDateDisabled() {
        return this.automation.articles.length == 0 || !this.automation.user;
    }



    async fetchArticles(event: any) {
        if (typeof event == 'string') {
            this.meta.search = event;
            try {
                const { data } = await getArticles(this.meta);
                return data.data.map((item: any) => {
                    return {
                        value: item.id,
                        text: `${item.label}`,
                    };
                });
            } catch {
                return;
            }
        }
        return []
    }

    deleteArticle(article: any) {
        const index = this.automation.articles.indexOf(article);
        if (index > -1) { // only splice array when item is found
            this.automation.articles.splice(index, 1); // 2nd parameter means remove one item only
        }
    }

    async fetchUsers(event: any) {
        console.log('LOOOOOG')
        console.log(event)
        if (typeof event == 'string') {
            this.meta.search = event;
            try {
                const { data } = await getUsers(this.meta);
                return data.data.map((item: any) => {
                    return {
                        value: item.id,
                        text: `${item.lastname} ${item.firstname}`,
                    };
                });
            } catch {
                return;
            }
        }
        return []
    }

    @Watch('article', { immediate: true })
    async onArticleChange(value: any) {
        const $vs = (this as any).$vs;
        //@ts-ignore
        this.$vs.loading({
            //@ts-ignore
            container: this.$refs.loadingContracts.$el,
        });

        const { data } = await getArticle(value);
        console.log("=========>")
        console.log(data)
        console.log(this.automation.articles);
        for (const article in this.automation.articles) {
            const active = this.automation.articles[article];
            if (active.id && active.id == data.id) {
                console.log("EXISTE")
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    //@ts-ignore
                    text: "Cet article est déjà dans votre liste",
                });
                //@ts-ignore
                this.$vs.loading.close(this.$refs.loadingContracts.$el);
                return
            }
        }
        //@ts-ignore
        this.automation.articles.push(data);
        this.article = [];
        //@ts-ignore
        this.$vs.loading.close(this.$refs.loadingContracts.$el);
    }

    @Watch('user', { immediate: true })
    async onUserSelected(value: any) {
        console.log(value)
        //@ts-ignore
        this.$vs.loading({
            //@ts-ignore
            container: this.$refs.loadingContracts.$el,
        });
        const { data } = await getUser(value);
        this.automation.user = data;
        //@ts-ignore
        this.$vs.loading.close(this.$refs.loadingContracts.$el);
    }

    async created() {
        this.user = undefined;
        this.article = undefined;
    }

    async post() {
        const $vs = (this as any).$vs;
        //@ts-ignore
        this.$vs.loading({
            //@ts-ignore
            container: this.$refs.loadingContracts.$el,
        });
        try {
            const date = this.automation.start_at;
            this.automation.start_at = date.toDate();
            const { data } = await postAutomation(this.automation)
            console.log(data)
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Création',
                text: `Création de l'automatisation réussie`,
            });
            this.automation = automationReset;
            this.showAddAutomation = false;
            this.reload = true;
        } catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                //@ts-ignore
                text: error.response.data.message,
            });
            //@ts-ignore
            this.$vs.loading.close(this.$refs.loadingContracts.$el);
            return;
        }
        //@ts-ignore
        this.$vs.loading.close(this.$refs.loadingContracts.$el);
    }
}
